<template>
  <div class="user-scheduled-posts">
    <profile-nav class="my-3"/>

    <!-- <div class="d-flex justify-content-start align-items-center">
      <b-btn class="mr-2" variant="outline-primary">
        Edit Post Schedule Times
      </b-btn>
      <b-btn variant="outline-primary">
        Pause
      </b-btn>
    </div> -->

    <b-row v-if="scheduledPosts">
      <b-col cols="12" md="6">
        <b-list-group class="my-2">
          <b-list-group-item class="d-flex flex-row justify-content-between">
            <h3>Queued ({{ (scheduledPosts && Array.isArray(scheduledPosts.queued)) ? scheduledPosts.queued.length : 0 }})</h3>
            <b-btn :disabled="!Array.isArray(scheduledPosts.queued) || scheduledPosts.queued.length === 0" @click="removeAllItems" variant="outline-danger">Remove all</b-btn>
          </b-list-group-item>
          <draggable v-if="Array.isArray(scheduledPosts.queued) && scheduledPosts.queued.length"
            :disabled="disableDraggable" handle=".drag-handle" v-model="scheduledPosts.queued" @end="updateOrder">
              <transition-group>
                <b-list-group-item class="d-flex flex-row align-items-start" v-for="item in scheduledPosts.queued" :key="item.id">
                  <div class="drag-handle flex-shrink-0 h-100 pt-1" :class="{ 'text-muted': disableDraggable }" :style="{ width: '20px' }">
                    <font-awesome-icon icon="bars" size="sm"/>
                  </div>
                  <div class="flex-fill d-flex flex-column text-truncate mt-1 mr-3">
                    <template v-if="item.job && item.job.id">
                      <p class="font-weight-bold m-0">{{ item.job.title }}</p>
                      <job-key-stats :job="item.job" include-type hide-labels hide-referral-bonus iconSize="lg"/>
                    </template>
                    <template v-if="item.contentShare && item.contentShare.id">
                      <p class="font-weight-bold text-truncate m-0">{{ item.contentShare.title }}</p>
                      <content-key-stats :contentShare="item.contentShare" include-type hide-labels iconSize="lg"/>
                    </template>
                    <div class="d-flex flex-row" v-if="item.text">
                      <font-awesome-icon class="mt-1 mr-2" icon="font"/>
                      <p class="text-wrap m-0">{{ item.text }}</p>
                    </div>
                    <!-- <div class="d-flex flex-row">
                      <font-awesome-icon class="mt-1 mr-2" icon="font"/>
                      <p class="text-wrap m-0" v-if="textChanges[item.id] || item.text">{{ textChanges[item.id] || item.text }}</p>
                      <p class="font-italic m-0" v-else>(No message)</p>
                      <b-btn class="flex-shrink-0 ml-1 p-0" size="sm" title="Edit Text" v-b-toggle="`edit-text-${item.id}`" variant="transparent">
                        <font-awesome-icon icon="pencil-alt" size="sm"/>
                      </b-btn>
                    </div>
                    <b-collapse :id="`edit-text-${item.id}`">
                      <b-form-group class="w-100">
                        <b-form-textarea placeholder="Enter your custom share text here" v-model="textChanges[item.id]"/>
                      </b-form-group>
                      <b-form-group class="w-100">
                        <b-btn :disabled="waiting[item.id]" @click="() => updateItemText(item.id)" variant="outline-success">Update</b-btn>
                      </b-form-group>
                    </b-collapse> -->
                    <div class="d-flex flex-row" v-if="item.url">
                      <font-awesome-icon class="mt-1 mr-2" icon="globe"/>
                      <a class="font-italic" :href="item.url" target="_blank">{{ item.url.replace(/http(s)?:\/\/(www.)?/, '') }}</a>
                    </div>
                    <div class="d-flex flex-row">
                      <font-awesome-icon class="mt-1 mr-2" icon="clock"/>
                      <span class="font-italic" v-if="item.sendAt">{{ item.sendAt | formatDate('Do MMM, YYYY - HH:mm') }}</span>
                      <span class="font-italic" v-else>Loading...</span>
                    </div>
                  </div>
                  <b-btn class="flex-shrink-0 border-0 rounded-circle m-1" size="sm" variant="outline-danger" :style="{ 'min-width': '30px' }"
                    :disabled="waiting[item.id]" title="Remove Item" @click="() => removeItem(item.id)">
                      <b-spinner v-if="waiting[item.id]" variant="primary"/>
                      <font-awesome-icon v-else icon="trash" size="sm"/>
                  </b-btn>
                </b-list-group-item>
              </transition-group>
          </draggable>
          <b-list-group-item v-else>
            <p>Posts you schedule will appear here.<br/>
              Browse <router-link :to="{ name: 'Dashboard' }">campaigns</router-link>,
              <router-link :to="{ name: 'CampaignJobIndex' }">jobs</router-link> or
              <router-link :to="{ name: 'CampaignContentShareIndex' }">content</router-link> to add items to your queue.</p>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-list-group class="my-2">
          <b-list-group-item>
            <h3>Sent ({{ (scheduledPosts && Array.isArray(scheduledPosts.sent)) ? scheduledPosts.sent.length : 0 }})</h3>
          </b-list-group-item>
          <template v-if="Array.isArray(scheduledPosts.sent) && scheduledPosts.sent.length">
            <b-list-group-item class="d-flex flex-column align-items-start" v-for="item in scheduledPosts.sent" :key="item.id">
              <template v-if="item.job && item.job.id">
                <p class="font-weight-bold m-0">{{ item.job.title }}</p>
                <job-key-stats :job="item.job" include-type hide-labels hide-referral-bonus iconSize="lg"/>
              </template>
              <template v-if="item.contentShare && item.contentShare.id">
                <p class="font-weight-bold text-truncate m-0">{{ item.contentShare.title }}</p>
                <content-key-stats :contentShare="item.contentShare" include-type hide-labels iconSize="lg"/>
              </template>
              <div class="d-flex flex-row" v-if="item.text">
                <font-awesome-icon class="mt-1 mr-2" icon="font"/>
                <p class="font-italic m-0">{{ item.text }}</p>
              </div>
              <div class="d-flex flex-row" v-if="item.url">
                <font-awesome-icon class="mt-1 mr-2" icon="globe"/>
                <a class="font-italic" :href="item.url" target="_blank">{{ item.url.replace(/http(s)?:\/\/(www.)?/, '') }}</a>
              </div>
              <div class="d-flex flex-row" v-if="item.sendAt">
                <font-awesome-icon class="mt-1 mr-2" icon="clock"/>
                <span class="font-italic">{{ item.sendAt | formatDate('Do MMM, YYYY - HH:mm') }}</span>
              </div>
            </b-list-group-item>
          </template>
          <b-list-group-item v-else>
            <p>Posts queued & then sent will appear here.</p>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ProfileNav from '@/components/users/ProfileNav';
import Draggable from 'vuedraggable';
import JobKeyStats from '@src/components/jobs/key-stats';
import ContentKeyStats from '@src/components/content-share/KeyStats';
import { mapRoot } from '@src/mixins/root';

const UserScheduledPostFragment = gql`
  fragment UserScheduledPostDetails on UserScheduledPost {
    id
    provider
    event {
      id
      title
    }
    job {
      id
      title
    }
    contentShare {
      id
      title
    }
    text
    url
    createdAt
    sendAt
  }
`;

const ListUserScheduledPostsQuery = gql`
  query ListUserScheduledPostsQuery {
    user {
      id
      queued: scheduledPosts(where: { OR: [ { sendAt_gte: "NOW" }, { sendAt: null } ] }, order: QUEUED_ASC) {
        ...UserScheduledPostDetails
      }
      sent: scheduledPosts(where: { sendAt_lte: "NOW" }, order: QUEUED_DESC) {
        ...UserScheduledPostDetails
      }
    }
  }
  ${UserScheduledPostFragment}
`;
const UpdateUserScheduledPostOrderMutation = gql`
  mutation UpdateUserScheduledPostOrder($postIDs: [ ID! ]!) {
    updateUserScheduledPostOrder(postIDs: $postIDs)
  }
`;
const RemoveUserScheduledPostMutation = gql`
  mutation RemoveUserScheduledPost($postID: ID!) {
    deleteUserScheduledPost(where: { id: $postID })
  }
`;
const RemoveAllUserScheduledPostsMutation = gql`
  mutation RemoveUserScheduledPost($postIDs: [ ID! ]!) {
    deleteManyUserScheduledPosts(where: { id_in: $postIDs })
  }
`;

const ORDER_KEY = '--ORDER--';
const REMOVE_ALL_KEY = '--REMOVE-ALL--';

export default {
  components: {
    ProfileNav,
    Draggable,
    JobKeyStats,
    ContentKeyStats,
  },
  data: () => ({
    queuedOrder: null,
    textChanges: null,
    waiting: null,
  }),
  created() {
    // this.textChanges = {};
    this.waiting = {};
  },
  apollo: {
    scheduledPosts: {
      query: ListUserScheduledPostsQuery,
      update({ user }) {
        const { queued, sent } = user || {};
        return { queued, sent };
      },
      result({ loading, data }) {
        if (!loading && data && data.user) {
          const { queued } = this.scheduledPosts;
          this.queuedOrder = (Array.isArray(queued) ? queued : []).map(({ id }) => id);
        }
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'user' ]),
    disableDraggable() {
      const { queued } = this.scheduledPosts || {};
      const { [ORDER_KEY]: orderWaiting, [REMOVE_ALL_KEY]: removeAllWaiting } = this.waiting || {};
      return orderWaiting === true || removeAllWaiting === true || !Array.isArray(queued) || queued.length <= 1;
    },
  },
  methods: {
    // async updateItemText(postID) {
    //   try {
    //     this.$assert(postID, new Error('Expected postID to be passed'));
    //     if (this.waiting[postID] === true) {
    //       return;
    //     } else {
    //       this.waiting[postID] = true;
    //     }

    //     await this.$apollo.mutate({
    //       mutation: RemoveUserScheduledPostMutation,
    //       variables: { postID },
    //     });

    //     await wait('1s');
    //     this.$apollo.queries.scheduledPosts.refresh();
    //     this.$notification({
    //       message: 'Queued post removed',
    //       variant: 'success',
    //     });
    //   } catch (err) {
    //     this.$log.error(err);
    //     this.$notifyErr('Failed to remove scheduled post');
    //   } finally {
    //     delete this.waiting[postID];
    //   }
    // },
    async updateOrder() {
      try {
        this.$assert(this.scheduledPosts && Array.isArray(this.scheduledPosts.queued) &&
          this.scheduledPosts.queued.length, new Error('No items in the queue'));
        this.waiting[ORDER_KEY] = true;

        const postIDs = this.scheduledPosts.queued.map(({ id }) => id);

        await this.$apollo.mutate({
          mutation: UpdateUserScheduledPostOrderMutation,
          variables: { postIDs },
        });

        this.$apollo.queries.scheduledPosts.refresh();
        this.$notification({
          message: 'Queue order updated',
          variant: 'success',
        });
      } catch (err) {
        this.$log.error(err);
        this.$notifyErr('Failed to update queue order');
      } finally {
        delete this.waiting[ORDER_KEY];
      }
    },
    async removeItem(postID) {
      try {
        this.$assert(postID, new Error('Expected postID to be passed'));
        if (this.waiting[postID] === true) {
          return;
        } else {
          this.waiting[postID] = true;
        }

        await this.$apollo.mutate({
          mutation: RemoveUserScheduledPostMutation,
          variables: { postID },
        });

        this.$apollo.queries.scheduledPosts.refresh();
        this.$notification({
          message: 'Queued post removed',
          variant: 'success',
        });
      } catch (err) {
        this.$log.error(err);
        this.$notifyErr('Failed to remove scheduled post');
      } finally {
        delete this.waiting[postID];
      }
    },
    async removeAllItems() {
      try {
        this.$assert(this.scheduledPosts && Array.isArray(this.scheduledPosts.queued) &&
          this.scheduledPosts.queued.length, new Error('No items in the queue'));
        this.waiting[REMOVE_ALL_KEY] = true;

        await this.$apollo.mutate({
          mutation: RemoveAllUserScheduledPostsMutation,
          variables: { postIDs: this.queuedOrder },
        });

        this.$apollo.queries.scheduledPosts.refresh();
        this.$notification({
          message: 'All queued posts removed',
          variant: 'success',
        });
      } catch (err) {
        this.$log.error(err);
        this.$notifyErr('Failed to remove all scheduled posts');
      } finally {
        delete this.waiting[REMOVE_ALL_KEY];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/User/ScheduledPosts.vue